module.exports = __webpack_public_path__ + "img/banner.b321f7eb.svg";